import { render, staticRenderFns } from "./EMailForm.vue?vue&type=template&id=a68f35c0&scoped=true&"
import script from "./EMailForm.vue?vue&type=script&lang=js&"
export * from "./EMailForm.vue?vue&type=script&lang=js&"
import style0 from "./EMailForm.vue?vue&type=style&index=0&id=a68f35c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68f35c0",
  null
  
)

export default component.exports